// src/routes/RequireAuth.tsx

import React from "react";
import { Navigate } from "react-router-dom";
import { userService } from "../services/UserServices";

export const isAuthenticated = async () => {
  try {
    const resp = await userService.getCurrentUser();
    return resp && resp.status === 200;
  } catch (error) {
    return false;
  } // Check if the user is authenticated
};

interface RequireAuthProps {
  children: JSX.Element;
}

const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default RequireAuth;
